/**
 * Converte o texto de um input decimal (aceita vírgula ou ponto como
 * separador, ex.: "1,5" ou "1.5") para `number` JS.
 * Retorna `null` quando o valor é vazio/inválido.
 */
export const parseDecimalInputValue = (
  value: string | number | null | undefined
): number | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(String(value).replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Formata um `number` (vindo da API) para a string exibida no input
 * decimal — vírgula como separador (pt-BR). Retorna `null` quando o valor
 * é nulo/indefinido.
 */
export const formatDecimalInputValue = (
  value: number | null | undefined,
  maximumFractionDigits = 3
): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  return value.toLocaleString('pt-BR', { maximumFractionDigits });
};
